import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';
import { TenantModuleLicenseView } from '@modules/bcm/settings/network-printers/pos-printer-license.util';
import { getModuleLicense } from '@modules/bcm/settings/network-printers/pos-printer-license.util';

export interface DocksiteLicenseUsageView {
    enabled: number;
}

export function isUnlimitedDocksiteQuota(quota: number | null | undefined): boolean {
    return quota == null;
}

export function getDocksiteModuleLicense(
    moduleLicenses: TenantModuleLicenseView[] | undefined,
): TenantModuleLicenseView | undefined {
    return getModuleLicense(moduleLicenses, BcmTenantPermission.DOCKSITE);
}

export function countDocksiteEnabledUsers(users: Array<{ docksiteEnabled?: boolean }> | undefined): number {
    return (users ?? []).filter((user) => !!user.docksiteEnabled).length;
}

export function canEnableDocksiteUser(
    moduleLicenses: TenantModuleLicenseView[] | undefined,
    enabledCount: number,
    isCurrentlyEnabled: boolean,
): boolean {
    if (isCurrentlyEnabled) {
        return true;
    }

    const license = getDocksiteModuleLicense(moduleLicenses);

    if (isUnlimitedDocksiteQuota(license?.quota)) {
        return true;
    }

    return enabledCount < Number(license?.quota ?? 0);
}

export function getDocksiteToggleDisabledReason(
    moduleLicenses: TenantModuleLicenseView[] | undefined,
    enabledCount: number,
    isCurrentlyEnabled: boolean,
): 'quotaExceeded' | null {
    if (canEnableDocksiteUser(moduleLicenses, enabledCount, isCurrentlyEnabled)) {
        return null;
    }

    return 'quotaExceeded';
}

export function formatDocksiteQuotaLabel(
    enabledCount: number,
    moduleLicenses: TenantModuleLicenseView[] | undefined,
): { enabled: number; quota: number | null } {
    const license = getDocksiteModuleLicense(moduleLicenses);

    return {
        enabled: enabledCount,
        quota: license?.quota ?? null,
    };
}
